// University of Nevada, Reno's undergraduate majors. Read on 2026-10-01
// from the official 2026-2027 University General Course Catalog
// (catalog.unr.edu, catoid=59), section 10, Degree Programs: "Bachelor's
// Degree Programs" lists ten headings (Agriculture, Liberal Arts, Business,
// ...), each a catalog search of the programs filed under it; every page of
// each list was read (the catalog site blocks plain curl, so the pages were
// fetched with a headless browser). The groups here are those headings, so a
// program filed under two (Agricultural Science under Agriculture and
// Science, the NevadaTeach programs) appears under both, as in the catalog.
// Kept: every bachelor's program, with the catalog's degree abbreviations.
// Folded: specializations and emphases into one line per major (e.g. six
// Environmental Science specializations, four Electrical Engineering
// emphases); B.A. and B.S. versions into one line. Left out: the (Online)
// copies, the Early Childhood Education copies at partner colleges (GBC,
// TMCC, WNC), the Lake Tahoe nursing track, the R.N. to BSN completion,
// Pre-Nursing (not a degree), the two-degree Dual Degree combinations, the
// accelerated BS/MS pathways, the interdisciplinary variant of Management
// and Marketing, and graduate programs and certificates.
const majors = {
    "slug": "university-of-nevada-reno",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in UNR's official 2026-2027 University General Course Catalog, under the catalog's own Degree Programs headings, with the degree it leads to. Specializations and emphases are folded into their major; online and partner-campus copies, minors, certificates and graduate programs are left out.",
    "groups": [
        {
            "name": "Agriculture",
            "source": {
                "label": "UNR 2026-2027 University General Course Catalog, Degree Programs",
                "url": "https://catalog.unr.edu/content.php?catoid=59&navoid=121304"
            },
            "majors": [
                {
                    "name": "Agricultural Science",
                    "degree": "B.S."
                },
                {
                    "name": "Animal Science",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biotechnology",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Forest Ecology and Management",
                    "degree": "B.S."
                },
                {
                    "name": "NevadaTeach Secondary Education and Agricultural Science",
                    "degree": "B.S./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Environmental Science",
                    "degree": "B.S./B.S. in Ed."
                },
                {
                    "name": "Nutrition",
                    "degree": "B.S."
                },
                {
                    "name": "Rangeland Ecology and Management",
                    "degree": "B.S."
                },
                {
                    "name": "Veterinary Science",
                    "degree": "B.S. in Vet. Sc."
                },
                {
                    "name": "Wildlife Ecology and Conservation",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Business",
            "source": {
                "label": "UNR 2026-2027 University General Course Catalog, Degree Programs",
                "url": "https://catalog.unr.edu/content.php?catoid=59&navoid=121304"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "B.S. in Bus. Ad."
                },
                {
                    "name": "Accounting and Information Systems",
                    "degree": "B.S. in Bus. Ad."
                },
                {
                    "name": "Economics",
                    "degree": "B.A., B.S. in Bus. Ad."
                },
                {
                    "name": "Finance",
                    "degree": "B.S. in Bus. Ad."
                },
                {
                    "name": "General Business",
                    "degree": "B.S. in Bus. Ad."
                },
                {
                    "name": "Information Systems",
                    "degree": "B.S. in Bus. Ad."
                },
                {
                    "name": "International Business",
                    "degree": "B.S. in Bus. Ad."
                },
                {
                    "name": "Management",
                    "degree": "B.S. in Bus. Ad."
                },
                {
                    "name": "Management and Marketing (Dual Major)",
                    "degree": "B.S. in Bus. Ad."
                },
                {
                    "name": "Marketing",
                    "degree": "B.S. in Bus. Ad."
                }
            ]
        },
        {
            "name": "Education & Human Development",
            "source": {
                "label": "UNR 2026-2027 University General Course Catalog, Degree Programs",
                "url": "https://catalog.unr.edu/content.php?catoid=59&navoid=121304"
            },
            "majors": [
                {
                    "name": "Early Childhood Education",
                    "degree": "B.S."
                },
                {
                    "name": "Human Development and Family Science",
                    "degree": "B.S."
                },
                {
                    "name": "Integrated Elementary Teaching",
                    "degree": "B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Agricultural Science",
                    "degree": "B.S./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Atmospheric Science",
                    "degree": "B.S./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Biology",
                    "degree": "B.S./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Chemistry",
                    "degree": "B.S. in Chem./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Environmental Science",
                    "degree": "B.S./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Geography",
                    "degree": "B.S./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Geology",
                    "degree": "B.S./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Mathematics",
                    "degree": "B.A./B.A. in Ed."
                }
            ]
        },
        {
            "name": "Engineering",
            "source": {
                "label": "UNR 2026-2027 University General Course Catalog, Degree Programs",
                "url": "https://catalog.unr.edu/content.php?catoid=59&navoid=121304"
            },
            "majors": [
                {
                    "name": "Aerospace Engineering",
                    "degree": "B.S. in A.E."
                },
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S. in B.M.E."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S. in Chem. E."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S. in C.E."
                },
                {
                    "name": "Computer Science and Engineering",
                    "degree": "B.S. in C.S.E."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S. in E.E."
                },
                {
                    "name": "Engineering Physics",
                    "degree": "B.S. in E.P."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S. in Env. E."
                },
                {
                    "name": "Geological Engineering",
                    "degree": "B.S. in Geol. Eng."
                },
                {
                    "name": "Industrial Engineering",
                    "degree": "B.S. in I.E."
                },
                {
                    "name": "Materials Science and Engineering",
                    "degree": "B.S. in M.S.E."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S. in M.E."
                },
                {
                    "name": "Metallurgical Engineering",
                    "degree": "B.S. in Met. E."
                },
                {
                    "name": "Mining Engineering",
                    "degree": "B.S. in Mining Engineering"
                }
            ]
        },
        {
            "name": "Health, Nursing & Medicine",
            "source": {
                "label": "UNR 2026-2027 University General Course Catalog, Degree Programs",
                "url": "https://catalog.unr.edu/content.php?catoid=59&navoid=121304"
            },
            "majors": [
                {
                    "name": "Kinesiology",
                    "degree": "B.S."
                },
                {
                    "name": "Nursing",
                    "degree": "BSN"
                },
                {
                    "name": "Nutrition",
                    "degree": "B.S."
                },
                {
                    "name": "Public Health",
                    "degree": "B.S."
                },
                {
                    "name": "Speech Pathology",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Interdisciplinary Programs",
            "source": {
                "label": "UNR 2026-2027 University General Course Catalog, Degree Programs",
                "url": "https://catalog.unr.edu/content.php?catoid=59&navoid=121304"
            },
            "majors": [
                {
                    "name": "Computational Linguistics",
                    "degree": "B.S."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Journalism",
            "source": {
                "label": "UNR 2026-2027 University General Course Catalog, Degree Programs",
                "url": "https://catalog.unr.edu/content.php?catoid=59&navoid=121304"
            },
            "majors": [
                {
                    "name": "Journalism",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism (Bilingual Media) and French",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism (Bilingual Media) and Spanish (Media Studies)",
                    "degree": "B.A."
                },
                {
                    "name": "PackTeach Secondary Education (Social Studies) and Journalism",
                    "degree": "B.A./B.A. in Ed."
                }
            ]
        },
        {
            "name": "Liberal Arts",
            "source": {
                "label": "UNR 2026-2027 University General Course Catalog, Degree Programs",
                "url": "https://catalog.unr.edu/content.php?catoid=59&navoid=121304"
            },
            "majors": [
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Instrumental Music",
                    "degree": "B.M."
                },
                {
                    "name": "Applied Jazz Music",
                    "degree": "B.M."
                },
                {
                    "name": "Applied Vocal Music",
                    "degree": "B.M."
                },
                {
                    "name": "Art",
                    "degree": "B.A., BFA"
                },
                {
                    "name": "Communication Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Composition",
                    "degree": "B.M."
                },
                {
                    "name": "Computational Linguistics",
                    "degree": "B.S."
                },
                {
                    "name": "Criminal Justice",
                    "degree": "B.A. in C.J."
                },
                {
                    "name": "Dance",
                    "degree": "B.A."
                },
                {
                    "name": "English",
                    "degree": "B.A."
                },
                {
                    "name": "French",
                    "degree": "B.A."
                },
                {
                    "name": "Gender, Race, and Identity",
                    "degree": "B.A."
                },
                {
                    "name": "Graphic Design",
                    "degree": "BFA"
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "Interdisciplinary Studies",
                    "degree": "B.A."
                },
                {
                    "name": "International Affairs",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism (Bilingual Media) and French",
                    "degree": "B.A."
                },
                {
                    "name": "Journalism (Bilingual Media) and Spanish (Media Studies)",
                    "degree": "B.A."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music Education",
                    "degree": "B.M."
                },
                {
                    "name": "Musical Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "PackTeach Secondary Education and Art",
                    "degree": "B.A./B.A. in Ed."
                },
                {
                    "name": "PackTeach Secondary Education and English",
                    "degree": "B.A./B.A. in Ed."
                },
                {
                    "name": "PackTeach Secondary Education and French",
                    "degree": "B.A./B.A. in Ed."
                },
                {
                    "name": "PackTeach Secondary Education and History",
                    "degree": "B.A./B.A. in Ed."
                },
                {
                    "name": "PackTeach Secondary Education and Political Science",
                    "degree": "B.A./B.A. in Ed."
                },
                {
                    "name": "PackTeach Secondary Education and Sociology",
                    "degree": "B.A./B.A. in Ed."
                },
                {
                    "name": "PackTeach Secondary Education and Spanish",
                    "degree": "B.A./B.A. in Ed."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Social Research Analytics",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                }
            ]
        },
        {
            "name": "Science",
            "source": {
                "label": "UNR 2026-2027 University General Course Catalog, Degree Programs",
                "url": "https://catalog.unr.edu/content.php?catoid=59&navoid=121304"
            },
            "majors": [
                {
                    "name": "Agricultural Science",
                    "degree": "B.S."
                },
                {
                    "name": "Atmospheric Science",
                    "degree": "B.S."
                },
                {
                    "name": "Biochemistry and Molecular Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biotechnology",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S. in Chem."
                },
                {
                    "name": "Computational Linguistics",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.S."
                },
                {
                    "name": "Forest Ecology and Management",
                    "degree": "B.S."
                },
                {
                    "name": "Geography",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Geology",
                    "degree": "B.S. in Geology"
                },
                {
                    "name": "Geophysics",
                    "degree": "B.S. in Geophysics"
                },
                {
                    "name": "Hydrogeology",
                    "degree": "B.S. in Hydrogeology"
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A., B.S."
                },
                {
                    "name": "Microbiology and Immunology",
                    "degree": "B.S."
                },
                {
                    "name": "Mining Engineering",
                    "degree": "B.S. in Mining Engineering"
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "NevadaTeach Secondary Education and Atmospheric Science",
                    "degree": "B.S./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Biology",
                    "degree": "B.S./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Chemistry",
                    "degree": "B.S. in Chem./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Geography",
                    "degree": "B.S./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Geology",
                    "degree": "B.S./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Mathematics",
                    "degree": "B.A./B.A. in Ed., B.S./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Microbiology and Immunology",
                    "degree": "B.S./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Physics",
                    "degree": "B.S./B.S. in Ed."
                },
                {
                    "name": "NevadaTeach Secondary Education and Professional Chemistry",
                    "degree": "B.S. in Chem./B.S. in Ed."
                },
                {
                    "name": "Nutrition",
                    "degree": "B.S."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Psychology",
                    "degree": "B.S., B.A."
                },
                {
                    "name": "Rangeland Ecology and Management",
                    "degree": "B.S."
                },
                {
                    "name": "Veterinary Science",
                    "degree": "B.S. in Vet. Sc."
                },
                {
                    "name": "Wildlife Ecology and Conservation",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Social Work",
            "source": {
                "label": "UNR 2026-2027 University General Course Catalog, Degree Programs",
                "url": "https://catalog.unr.edu/content.php?catoid=59&navoid=121304"
            },
            "majors": [
                {
                    "name": "Social Work",
                    "degree": "BSW"
                }
            ]
        }
    ]
};

export default majors;
